export default __webpack_public_path__ + "static/media/Iconly-Bold-Heart.13d9e1ca.svg";